import React from 'react'
import {
  Modal, ModalOverlay, ModalContent, ModalBody,
  Box, VStack, Text, Button,
} from '@chakra-ui/react'
import { motion, useReducedMotion } from 'framer-motion'
import CloseButton from './CloseButton'

const MotionContent = motion(ModalContent)

const WarningIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
       stroke="#B08D5B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
)

const cardVariants = (reduced) => reduced
  ? { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.15 } }, exit: { opacity: 0, transition: { duration: 0.1 } } }
  : {
      hidden:  { opacity: 0, scale: 0.92, y: 8 },
      visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.3, ease: [0.0, 0.0, 0.2, 1] } },
      exit:    { opacity: 0, scale: 0.95, transition: { duration: 0.2, ease: [0.4, 0.0, 1, 1] } },
    }

const NoMatchSheet = ({ isOpen, onClose, error }) => {
  const prefersReduced = useReducedMotion()
  const message = error
    ? 'Une erreur réseau est survenue. Vérifiez votre connexion et réessayez.'
    : 'Essayez de vous rapprocher ou de mieux cadrer l\'œuvre.'

  return (
    <Modal isOpen={isOpen} onClose={onClose} motionPreset="none" isCentered>
      <ModalOverlay
        bg="rgba(26,29,36,0.75)"
        as={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: prefersReduced ? 0.1 : 0.3 } }}
        exit={{ opacity: 0, transition: { duration: prefersReduced ? 0.1 : 0.25 } }}
      />
      <MotionContent
        variants={cardVariants(prefersReduced)}
        initial="hidden"
        animate="visible"
        exit="exit"
        bg="lumene.white"
        color="lumene.night"
        borderRadius="xl"
        maxW="360px"
        mx={5}
        p={6}
        position="relative"
        aria-labelledby="no-match-title"
      >
        <CloseButton onClick={onClose} position="absolute" top="8px" right="8px" />
        <ModalBody p={0}>
          <VStack spacing={4} textAlign="center">
            <WarningIcon />
            <Text id="no-match-title" as="h2" fontSize="xl" fontWeight="bold" lineHeight={1.2}>
              Aucune œuvre reconnue
            </Text>
            <Text fontSize="14px" color="lumene.night" opacity={0.8} lineHeight={1.6}>
              {message}
            </Text>
            <Button variant="lumenePrimary" w="100%" onClick={onClose}>
              Réessayer
            </Button>
          </VStack>
        </ModalBody>
      </MotionContent>
    </Modal>
  )
}

export default NoMatchSheet
